import type { DeviceViewSettingsTable } from '@ipfabric/utils';
import type {
  DeviceViewEntity,
  DeviceViewSettings,
} from 'components/DeviceView/deviceViewTypes';
import { produce } from 'immer';

export function updateDeviceViewEntityTables(
  deviceViewEntity: DeviceViewEntity,
  settings: DeviceViewSettings,
  tables: DeviceViewSettingsTable[],
): DeviceViewSettings {
  return produce(settings, (draft) => {
    switch (deviceViewEntity.deviceViewElement) {
      case 'node':
        if (deviceViewEntity.nodeType !== null) {
          draft.nodes[deviceViewEntity.nodeType] = tables;
        }
        break;
      case 'edge':
        if (deviceViewEntity.protocol) {
          draft.edges[deviceViewEntity.protocol] = tables;
        }
        break;
      case 'labels':
      case 'packetDetails':
      case 'pathlookupDebug':
        break;
      default:
        throw new Error('Unknown entity type');
    }
  });
}
